export const PROPERTY_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export const PROPERTY_TIERS = {
  PROVISIONAL: "truetour",
  PRO: "saleshub_pro",
  STANDARD: "saleshub",
} as const;

export type PROPERTY_TIERS = (typeof PROPERTY_TIERS)[keyof typeof PROPERTY_TIERS];

export const PROPERTY_TIER_NAMES = {
  truetour: "TrueTour",
  saleshub_pro: "SalesHub Pro",
  saleshub: "SalesHub",
};

export const PROPERTY_TIER_LEVEL = {
  truetour: 1,
  saleshub: 2,
  saleshub_pro: 3,
};
